import { buildRoutes, compileRoutes } from "@ctra/utils";
import {
  ChartFilters,
  ChartTimePeriod,
  DataDescriptorEntity,
  ISODuration,
  SavedChartState,
  SectionEntity
} from "@ctra/api";

import { base } from "./base/routes";
import { auth } from "./auth/routes";
import { overview, dashboards } from "./overview/routes";
import { farms } from "./farms/routes";
import { gamePlans } from "./game-plans/routes";
import { analytics } from "./analytics/routes";
import { settings } from "./settings/routes";
import { insights } from "./insights/routes";
import { timeline } from "./events/routes";
import { farmSummaries } from "./farm-summaries/routes";
import { iofc } from "./iofc/routes";

export interface URIState {
  zoom?: {
    dataDescriptorID: DataDescriptorEntity["id"];
    rootSectionID?: SectionEntity["id"];
    filters?: ChartFilters;
    legendValues?: Array<string>;
    isoDuration?: ISODuration;
    timePeriod?: ChartTimePeriod;
    view?: string;
  };
  timeline?: {
    disabled?: boolean;
  };
  navigation?: {
    farmSelect: {
      overview: {
        open: boolean;
      };
      sidebar: {
        open: boolean;
      };
    };
  };
  dialogPage?: {
    title: string;
  };
  savedChart?: SavedChartState;
  dashboard?: string;
}

/**
 * Route strings for Enterprise
 * @note the weird looking destructuring actually helps getting rid of circular imports in tests, no idea how
 */
export const Routes = buildRoutes({
  _root: "",
  auth,
  app: {
    ...base,
    overview,
    insights,
    farms,
    gamePlans,
    analytics,
    settings,
    dashboards,
    timeline,
    farmSummaries,
    iofc,
    helpCenter: {
      _root: "/helpcenter"
    }
  }
});

/**
 * Compiled route strings which are callable. It comes handy during
 * navigation as you do not need to individually compile any path.
 * @example
 * ```ts
 * assert(Routes.app.farms.farm === "/app/farms/:farmID/");
 * CompiledRoutes.app.farms.farm({ farmID: 1 });
 * // "/app/farms/1/"
 * ```
 */
export const CompiledRoutes = compileRoutes(Routes);
